// *********************
//    Modules scripts
// *********************

// MINIFIED Vendor file should be copied over via copyScripts.js (it is by default)

// IMPORT all modules here. Keep lib and minified files out this file.
// Except for the example below

//the import statments for CSS and JS can and should be exactly the same. Components that are CSS only should have some example markup in the HTML folder. The JS file is optional.
import 'modules/browserDetect';
import 'modules/bLazyInit';
import 'modules/printPage';
import 'lib/select';

// Inits
// import 'modules/charts';
// import 'modules/aosInit';
// import 'modules/chartsInit';
// import 'modules/countdownInit';

import 'modules/dropdown';
import 'modules/showhide';

import 'lib/closestPolyfill';

import '../components/navigation/navigation';
import '../components/countries/countries';
import '../components/back_to_top/back_to_top';
import '../components/accordion/accordion';
import '../components/search/search';
import '../components/cards/cards';
import '../components/cards/loma-cards'
import '../components/contact/contact';
import '../components/events/eventsTabs';
import '../components/events/eventsSort';
import '../components/inner-nav/inner-nav';
import '../components/social/social';
import '../components/modal/modal';
import '../components/memberroster/memberroster';
import '../components/metrics/metricsTracking';
import '../components/myinterests/myinterests';
import '../components/form-watcher/form-watcher';
import '../components/forms/form_validation';
import '../components/topic/topic';
import '../components/footer/footer';
import '../components/video/video';
import '../components/gallery/gallery';
import '../components/people/people';
import '../components/utility/utility';
import '../components/news/news';
import '../components/show-list/show-list';
import '../components/submit-animation/submit-animation';
import '../components/documentlist/documentlist';
import '../components/staffdirectory/staffdirectory';
import '../components/cap/cap';
import '../components/site-map/site-map';
import '../components/simple-scroll/simple-scroll';
import '../components/loma-homepage/prof-dev';
import '../components/tech-directory/tech-directory';
import '../components/course-catalog/course-catalog';
import '../components/magazine/magazine-feed';

// import '../components/text-to-accordion/text-to-accordion'



// WEBPACK FOOTER //
// ./app.js